import { Variant } from "shared/enums/VariantEnum";

interface Props {
  variant: Variant;
  text: string;
  widthClass?: string;
}

export default function Status({ variant, text, widthClass }: Props) {
  const getVariantSpecificBgColor = () => {
    if (variant === Variant.Warning) {
      return "bg-promBlue1";
    }

    if (variant === Variant.Danger) {
      return "bg-promRed1";
    }

    if (variant === Variant.Success) {
      return "bg-promDeepMint";
    }
  };

  return (
    <div
      className={`inline-block rounded-2.5xl py-0.5 px-3 text-white font-semibold ${getVariantSpecificBgColor()} ${
        widthClass ? widthClass : "w-auto"
      }`}
    >
      {text}
    </div>
  );
}
